(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const drawer = document.getElementById('ec-cart-drawer');
  if (!drawer) return;

  const body = drawer.querySelector('[data-ec-cart-drawer-body]');
  const footer = drawer.querySelector('[data-ec-cart-drawer-footer]');
  const subtotalEl = drawer.querySelector('[data-ec-cart-drawer-subtotal]');
  const subtotalLabelEl = drawer.querySelector('[data-ec-cart-drawer-subtotal-label]');
  const footerToggle = drawer.querySelector('[data-ec-cart-drawer-footer-toggle]');
  const shopKitsUrl = drawer.dataset.shopKitsUrl || '/';
  const sizeLabel = drawer.dataset.sizeLabel || 'Size';
  const emptyText = drawer.dataset.emptyText || 'Your cart is empty.';
  const continueLabel = drawer.dataset.continueLabel || 'Continue shopping';
  const loadingText = drawer.dataset.loadingText || 'Loading cart…';
  const moneyFormat = drawer.dataset.moneyFormat || '';
  const currency = drawer.dataset.currency || 'USD';
  const itemCountOneTemplate = drawer.dataset.itemCountOne || '@count item';
  const itemCountOtherTemplate = drawer.dataset.itemCountOther || '@count items';
  const hideSummaryLabel = drawer.dataset.hideSummary || 'Hide summary';
  const showSummaryLabel = drawer.dataset.showSummary || 'Show summary';
  const rashguardLabel = drawer.dataset.sizeRashguard || 'Size - Rashguard';
  const shortsLabel = drawer.dataset.sizeShorts || 'Size - Shorts';
  const removeLabel = drawer.dataset.remove || 'Remove';
  const qtyDecreaseLabel = drawer.dataset.qtyDecrease || 'Decrease quantity';
  const qtyIncreaseLabel = drawer.dataset.qtyIncrease || 'Increase quantity';

  const RASHGUARD_SIZES = ['XS', 'S', 'M', 'L', 'XL'];
  const SHORTS_SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL'];
  const productCache = new Map();
  let cartRequest = Promise.resolve();

  const formatItemCount = (count) => {
    const template = count === 1 ? itemCountOneTemplate : itemCountOtherTemplate;
    return template.replace('@count', count);
  };

  footerToggle?.addEventListener('click', () => {
    if (!footer) return;
    footer.classList.toggle('is-collapsed');
    const expanded = !footer.classList.contains('is-collapsed');
    footerToggle.setAttribute('aria-expanded', String(expanded));
    footerToggle.setAttribute(
      'aria-label',
      expanded ? hideSummaryLabel : showSummaryLabel
    );
  });

  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
    }).format(cents / 100);
  };

  const getRashguardSize = (item) => {
    if (Array.isArray(item.options_with_values)) {
      for (const option of item.options_with_values) {
        if (option.name?.toLowerCase() === 'size' && option.value) {
          return option.value;
        }
      }
    }

    if (item.option1 && item.option1 !== 'Default Title') {
      return item.option1;
    }

    return item.properties?.['Size - Rashguard'] || item.properties?.Size || 'M';
  };

  const getShortsSize = (item) => item.properties?.['Size - Compression Shorts'] || 'M';

  const itemHasVariantSize = (item) => {
    if (
      Array.isArray(item.options_with_values) &&
      item.options_with_values.some((option) => option.name?.toLowerCase() === 'size')
    ) {
      return true;
    }

    return Boolean(item.option1 && item.option1 !== 'Default Title');
  };

  const fetchProduct = async (handle) => {
    if (!handle) return null;

    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return null;

      const product = await response.json();
      productCache.set(handle, product);
      return product;
    } catch (error) {
      return null;
    }
  };

  const getOptionName = (option) => {
    if (typeof option === 'string') return option;
    if (option && typeof option.name === 'string') return option.name;
    return '';
  };

  const getSizeOptionIndex = (product) => {
    if (!Array.isArray(product?.options)) return -1;

    return product.options.findIndex(
      (option) => getOptionName(option).toLowerCase() === 'size'
    );
  };

  const isRashguardSizeAvailable = (product, size) => {
    const sizeIndex = getSizeOptionIndex(product);
    if (sizeIndex === -1) return true;

    return product.variants.some(
      (variant) => variant.available && variant.options[sizeIndex] === size
    );
  };

  const buildSelectOptions = (sizes, currentValue, isAvailable) =>
    sizes
      .map((size) => {
        const selected = size === currentValue ? ' selected' : '';
        const disabled = isAvailable && !isAvailable(size) ? ' disabled' : '';
        return `<option value="${size}"${selected}${disabled}>${size}</option>`;
      })
      .join('');

  const updateHeaderCartCount = async (cart) => {
    const cartButton = document.querySelector('.site-header__cart');
    if (!cartButton) return;

    let countBadge = cartButton.querySelector('.site-header__cart-count');
    const itemCount = cart?.item_count ?? 0;

    if (itemCount > 0) {
      if (!countBadge) {
        countBadge = document.createElement('sup');
        countBadge.className = 'site-header__cart-count';
        cartButton.appendChild(countBadge);
      }
      countBadge.textContent = String(itemCount);
    } else if (countBadge) {
      countBadge.remove();
    }
  };

  const queueCartUpdate = (task) => {
    cartRequest = cartRequest.then(task).catch(async () => {
      await refreshCartDrawer();
    });
    return cartRequest;
  };

  const changeLineQuantity = (lineKey, quantity) =>
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity }),
    }).then((response) => {
      if (!response.ok) throw new Error('Cart change failed');
      return response.json();
    });

  const changeShortsSize = (item, newSize) =>
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: item.key,
        quantity: item.quantity,
        properties: {
          ...(item.properties || {}),
          'Size - Compression Shorts': newSize,
        },
      }),
    }).then((response) => {
      if (!response.ok) throw new Error('Cart change failed');
      return response.json();
    });

  const changeRashguardPropertySize = (item, newSize) => {
    const properties = { ...(item.properties || {}) };
    properties['Size - Rashguard'] = newSize;
    delete properties.Size;

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: item.key,
        quantity: item.quantity,
        properties,
      }),
    }).then((response) => {
      if (!response.ok) throw new Error('Cart change failed');
      return response.json();
    });
  };

  const changeRashguardSize = async (item, product, newSize) => {
    const sizeIndex = getSizeOptionIndex(product);
    if (sizeIndex === -1) return null;

    const variant = product.variants.find(
      (entry) => entry.available && entry.options[sizeIndex] === newSize
    );

    if (!variant || variant.id === item.variant_id) return null;

    await changeLineQuantity(item.key, 0);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: variant.id,
            quantity: item.quantity,
            properties: {
              'Size - Compression Shorts': getShortsSize(item),
            },
          },
        ],
      }),
    });

    if (!response.ok) throw new Error('Cart add failed');
    return response.json();
  };

  const formatProductTitle = (rawTitle) => {
    if (!rawTitle) return '';

    const upper = rawTitle.toUpperCase();
    let sleeve = '';

    if (upper.includes(' SET LS') || upper.includes('L/S') || upper.includes(' LONG SLEEVE')) {
      sleeve = 'LS';
    } else if (upper.includes(' SET SS') || upper.includes('S/S') || upper.includes(' SHORT SLEEVE')) {
      sleeve = 'SS';
    }

    let name = rawTitle;
    const setIndex = upper.indexOf(' SET ');

    if (setIndex !== -1) {
      name = rawTitle.slice(0, setIndex);
    } else {
      const titleCaseSetIndex = rawTitle.toLowerCase().indexOf(' set ');
      if (titleCaseSetIndex !== -1) {
        name = rawTitle.slice(0, titleCaseSetIndex);
      }
    }

    name = name
      .replace(/\s*NO-GI COMPRESSION/gi, '')
      .replace(/\s*NO-GI/gi, '')
      .replace(/\s*COMPRESSION/gi, '')
      .trim();

    const titleCase = (value) =>
      value
        .toLowerCase()
        .split(' ')
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

    if (sleeve && name) {
      return `${titleCase(name)} Set ${sleeve}`;
    }

    if (name) {
      return titleCase(name);
    }

    return rawTitle;
  };

  const usesVariantRashguardSize = (item, product) => {
    if (!product || getSizeOptionIndex(product) === -1) return false;
    return itemHasVariantSize(item);
  };

  const renderCart = async (cart) => {
    if (!body || !footer || !subtotalEl) return;

    try {
      await updateHeaderCartCount(cart);

      if (!cart?.items?.length) {
        body.innerHTML = `
          <p class="ec-cart-drawer__empty-text">${emptyText}</p>
          <a class="ec-cart-drawer__empty-cta" href="${shopKitsUrl}">${continueLabel}</a>
        `;
        footer.hidden = true;
        return;
      }

      const handles = [...new Set(cart.items.map((item) => item.handle).filter(Boolean))];
      const productResults = await Promise.all(handles.map((handle) => fetchProduct(handle)));
      const productsByHandle = {};

      handles.forEach((handle, index) => {
        if (productResults[index]) {
          productsByHandle[handle] = productResults[index];
        }
      });

      const itemsHtml = cart.items
        .map((item) => {
          const product = productsByHandle[item.handle];
          const rashguardSize = getRashguardSize(item);
          const shortsSize = getShortsSize(item);
          const hasVariantRashguardSize = usesVariantRashguardSize(item, product);
          const lineKey = String(item.key || item.id);
          const imageHtml = item.image
            ? `<img class="ec-cart-drawer__item-image" src="${item.image}" alt="" width="72" height="88" loading="lazy">`
            : `<div class="ec-cart-drawer__item-image"></div>`;

          const rashguardSelect = `
              <label class="ec-cart-drawer__option">
                <span class="ec-cart-drawer__option-label">${rashguardLabel}</span>
                <select
                  class="ec-cart-drawer__size-select"
                  data-ec-cart-rashguard-size
                  data-line-key="${lineKey}"
                  aria-label="${rashguardLabel}"
                >
                  ${buildSelectOptions(
                    RASHGUARD_SIZES,
                    rashguardSize,
                    hasVariantRashguardSize ? (size) => isRashguardSizeAvailable(product, size) : null
                  )}
                </select>
              </label>
            `;

        const shortsSelect = `
          <label class="ec-cart-drawer__option">
            <span class="ec-cart-drawer__option-label">${shortsLabel}</span>
            <select
              class="ec-cart-drawer__size-select"
              data-ec-cart-shorts-size
              data-line-key="${lineKey}"
              aria-label="${shortsLabel}"
            >
              ${buildSelectOptions(SHORTS_SIZES, shortsSize)}
            </select>
          </label>
        `;

        return `
          <li class="ec-cart-drawer__item" data-line-key="${lineKey}">
            <a href="${item.url}" class="ec-cart-drawer__item-media">${imageHtml}</a>
            <div class="ec-cart-drawer__item-main">
              <p class="ec-cart-drawer__item-title">
                <a href="${item.url}">${formatProductTitle(item.product_title)}</a>
              </p>
              <div class="ec-cart-drawer__item-options">${rashguardSelect}${shortsSelect}</div>
              <div class="ec-cart-drawer__item-price-row">
                <div class="ec-cart-drawer__item-controls">
                  <div class="ec-cart-drawer__quantity" data-line-key="${lineKey}">
                    <button
                      type="button"
                      class="ec-cart-drawer__quantity-btn"
                      data-ec-cart-qty-decrease
                      data-line-key="${lineKey}"
                      aria-label="${qtyDecreaseLabel}"
                      ${item.quantity <= 1 ? 'disabled' : ''}
                    >&minus;</button>
                    <span class="ec-cart-drawer__quantity-value">${item.quantity}</span>
                    <button
                      type="button"
                      class="ec-cart-drawer__quantity-btn"
                      data-ec-cart-qty-increase
                      data-line-key="${lineKey}"
                      aria-label="${qtyIncreaseLabel}"
                    >+</button>
                  </div>
                  <button
                    type="button"
                    class="ec-cart-drawer__remove"
                    data-ec-cart-remove
                    data-line-key="${lineKey}"
                  >${removeLabel}</button>
                </div>
                <p class="ec-cart-drawer__item-price">${formatMoney(item.final_line_price)}</p>
              </div>
            </div>
          </li>
        `;
      })
      .join('');

    body.innerHTML = `<ul class="ec-cart-drawer__items" role="list">${itemsHtml}</ul>`;
    subtotalEl.textContent = formatMoney(cart.total_price);

    if (subtotalLabelEl) {
      const subtotalBase = subtotalLabelEl.dataset.subtotalBase || 'Subtotal';
      subtotalLabelEl.textContent = `${subtotalBase} · ${formatItemCount(cart.item_count)}`;
    }

    footer.hidden = false;
    footer.classList.remove('is-collapsed');
    footerToggle?.setAttribute('aria-expanded', 'true');
    footerToggle?.setAttribute('aria-label', hideSummaryLabel);
    } catch (error) {
      body.innerHTML = `<p class="ec-cart-drawer__loading">${loadingText}</p>`;
    }
  };

  const getCartItemByKey = async (lineKey) => {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Cart fetch failed');
    const cart = await response.json();
    return cart.items.find((item) => String(item.key || item.id) === String(lineKey));
  };

  const refreshCartDrawer = async () => {
    if (!body) return;
    body.innerHTML = `<p class="ec-cart-drawer__loading">${loadingText}</p>`;
    footer.hidden = true;

    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Cart fetch failed');
      const cart = await response.json();
      await renderCart(cart);
    } catch (error) {
      body.innerHTML = `<p class="ec-cart-drawer__loading">${loadingText}</p>`;
    }
  };

  const setLineUpdating = (lineKey, isUpdating) => {
    body
      ?.querySelector(`.ec-cart-drawer__item[data-line-key="${lineKey}"]`)
      ?.classList.toggle('is-updating', isUpdating);
  };

  body?.addEventListener('change', (event) => {
    const rashguardSelect = event.target.closest('[data-ec-cart-rashguard-size]');
    const shortsSelect = event.target.closest('[data-ec-cart-shorts-size]');

    if (rashguardSelect) {
      const lineKey = rashguardSelect.dataset.lineKey;
      const newSize = rashguardSelect.value;

      queueCartUpdate(async () => {
        setLineUpdating(lineKey, true);
        const item = await getCartItemByKey(lineKey);
        if (!item || getRashguardSize(item) === newSize) return;

        const product = await fetchProduct(item.handle);

        if (usesVariantRashguardSize(item, product)) {
          await changeRashguardSize(item, product, newSize);
        } else {
          await changeRashguardPropertySize(item, newSize);
        }

        await refreshCartDrawer();
      });

      return;
    }

    if (shortsSelect) {
      const lineKey = shortsSelect.dataset.lineKey;
      const newSize = shortsSelect.value;

      queueCartUpdate(async () => {
        setLineUpdating(lineKey, true);
        const item = await getCartItemByKey(lineKey);
        if (!item || getShortsSize(item) === newSize) return;

        await changeShortsSize(item, newSize);
        await refreshCartDrawer();
      });
    }
  });

  body?.addEventListener('click', (event) => {
    const decrease = event.target.closest('[data-ec-cart-qty-decrease]');
    const increase = event.target.closest('[data-ec-cart-qty-increase]');
    const removeButton = event.target.closest('[data-ec-cart-remove]');

    if (decrease) {
      const lineKey = decrease.dataset.lineKey;

      queueCartUpdate(async () => {
        setLineUpdating(lineKey, true);
        const item = await getCartItemByKey(lineKey);
        if (!item) return;

        await changeLineQuantity(lineKey, Math.max(0, item.quantity - 1));
        await refreshCartDrawer();
      });

      return;
    }

    if (increase) {
      const lineKey = increase.dataset.lineKey;

      queueCartUpdate(async () => {
        setLineUpdating(lineKey, true);
        const item = await getCartItemByKey(lineKey);
        if (!item) return;

        await changeLineQuantity(lineKey, item.quantity + 1);
        await refreshCartDrawer();
      });

      return;
    }

    if (removeButton) {
      const lineKey = removeButton.dataset.lineKey;

      queueCartUpdate(async () => {
        setLineUpdating(lineKey, true);
        await changeLineQuantity(lineKey, 0);
        await refreshCartDrawer();
      });
    }
  });

  window.ecOpenCartDrawer = async () => {
    drawer.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ec-cart-drawer-open');
    document.documentElement.style.overflow = 'hidden';
    await refreshCartDrawer();
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.hidden = true;
    document.body.classList.remove('ec-cart-drawer-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  };

  drawer.querySelectorAll('[data-ec-cart-drawer-close]').forEach((button) => {
    button.addEventListener('click', closeDrawer);
  });

  const checkoutLink = drawer.querySelector('[data-ec-cart-checkout]');
  const checkoutUrl = drawer.dataset.checkoutUrl;

  checkoutLink?.addEventListener('click', (event) => {
    const isLocalDev =
      window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';

    if (!isLocalDev || !checkoutUrl) return;

    event.preventDefault();
    closeDrawer();
    window.location.assign(checkoutUrl);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ec-open-cart-drawer]');
    if (trigger) {
      event.preventDefault();
      window.ecOpenCartDrawer();
      return;
    }

    const cartLink = event.target.closest('a[href]');
    if (cartLink && !cartLink.closest('.ec-cart-drawer')) {
      try {
        const url = new URL(cartLink.href, window.location.origin);
        if (url.pathname.endsWith('/cart')) {
          event.preventDefault();
          window.ecOpenCartDrawer();
        }
      } catch (error) {
        /* ignore */
      }
    }
  });

  window.ecRefreshCartDrawer = refreshCartDrawer;

  const cartOpenParam = 'open_cart';
  const initialParams = new URLSearchParams(window.location.search);

  if (initialParams.get(cartOpenParam) === '1') {
    initialParams.delete(cartOpenParam);
    const nextSearch = initialParams.toString();
    const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash}`;
    history.replaceState(null, '', nextUrl);
    window.ecOpenCartDrawer();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ec-polish"] && !Shopify.designMode) return;
  try {
    (function initLandingFoldLock() {
    const body = document.body;
    if (!body.classList.contains('template-index')) return;

    const HEIGHT_VARS = [
      '--ec-landing-hero-height',
      '--ec-landing-drop-height',
      '--ec-landing-value-height',
      '--ec-landing-fold-height',
      '--ec-landing-hero-share',
      '--ec-landing-drop-scale',
      '--ec-landing-split-hero-height',
    ];

    let lockedWidth = 0;
    let lockedMode = '';
    let lockFrame = null;
    let landscapeMetrics = null;
    let stackedFoldMetrics = null;
    let portraitMetrics = null;
    let portraitFoldSealed = false;
    let svhProbe = null;

    const clearLocks = () => {
      HEIGHT_VARS.forEach((name) => body.style.removeProperty(name));
      body.classList.remove('ec-landing-heights-locked');
      body.classList.remove('ec-landing-landscape-fold');
      body.classList.remove('ec-landing-portrait-stacked-fold');
      body.classList.remove('ec-landing-stacked-fold');
      landscapeMetrics = null;
      stackedFoldMetrics = null;
      portraitMetrics = null;
      portraitFoldSealed = false;
      lockedMode = '';

      const dropWrapper = document.querySelector(
        '#main-content > .shopify-section:has(.ec-drop-slider)'
      );
      const dropSlider = dropWrapper?.querySelector('.ec-drop-slider');
      dropSlider?.style.removeProperty('min-height');
      dropWrapper?.style.removeProperty('min-height');
    };

    const getSmallViewportHeight = () => {
      if (!svhProbe) {
        svhProbe = document.createElement('div');
        svhProbe.setAttribute('aria-hidden', 'true');
        svhProbe.style.cssText =
          'position:fixed;top:0;left:0;width:0;height:100svh;pointer-events:none;visibility:hidden;';
        document.documentElement.appendChild(svhProbe);
      }

      return Math.round(svhProbe.getBoundingClientRect().height);
    };

    const getHeaderOffset = () => {
      const value = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--site-header-offset')
      );
      return Number.isFinite(value) ? Math.round(value) : 0;
    };

    const getFoldHeight = () => Math.max(0, getSmallViewportHeight() - getHeaderOffset());

    const getMainContentTop = () => {
      const main = document.getElementById('main-content');
      if (main) {
        const measuredTop = Math.round(main.getBoundingClientRect().top);
        if (measuredTop >= 0) {
          return measuredTop;
        }
      }

      return getHeaderOffset();
    };

    const getPortraitFoldHeight = () => {
      const mainTop = getMainContentTop();
      const viewport = window.visualViewport;

      if (viewport) {
        return Math.max(0, Math.round(viewport.offsetTop + viewport.height) - mainTop);
      }

      return getFoldHeight();
    };

    const measureSplitHeroHeight = () => {
      const splitWrapper = document.querySelector(
        '#main-content > .shopify-section:has(.ec-gender-split-hero)'
      );

      if (!splitWrapper) {
        return Math.round(window.innerWidth / 2);
      }

      const measured = Math.round(splitWrapper.getBoundingClientRect().height);
      return measured > 0 ? measured : Math.round(window.innerWidth / 2);
    };

    const isInLandingFoldZone = () => {
      if (window.scrollY < 32) {
        return true;
      }

      const foldHeight =
        portraitMetrics?.foldHeight || readLandingVar('--ec-landing-fold-height') || window.innerHeight;

      return window.scrollY < Math.max(64, Math.round(foldHeight * 0.2));
    };

    const isPortraitFoldFrozen = () =>
      portraitFoldSealed &&
      lockedMode === 'portrait-mobile' &&
      body.classList.contains('ec-landing-portrait-stacked-fold');

    const isLandingFoldAtRest = () => isInLandingFoldZone();

    const getFoldTargetBottom = (foldHeight, metrics) => {
      if (metrics?.screenBottom && metrics?.mainTop != null && !foldHeight) {
        return metrics.screenBottom;
      }

      return getMainContentTop() + foldHeight;
    };

    const readLandingVar = (name) => {
      const value = parseFloat(getComputedStyle(body).getPropertyValue(name));
      return Number.isFinite(value) ? Math.round(value) : 0;
    };

    const getHeroShare = () => {
      const value = parseFloat(getComputedStyle(body).getPropertyValue('--ec-landing-hero-share'));
      return Number.isFinite(value) && value > 0 ? value : 0.6;
    };

    const getHeroShareForMode = (mode) => {
      if (mode === 'portrait-mobile') {
        const foldHeight = getPortraitFoldHeight();
        const splitHeight = Math.round(window.innerWidth / 2);
        if (foldHeight > 0) {
          return Math.max(0, (foldHeight - splitHeight) / foldHeight);
        }
        return 0.52;
      }
      if (mode === 'compact-landscape' || mode === 'landscape-mobile') return 1;
      if (mode === 'tablet' || mode === 'desktop') return 1;
      return getHeroShare();
    };

    const notifyDropSliderReflow = () => {
      document.querySelectorAll('[data-ec-drop-slider]').forEach((section) => {
        section.dispatchEvent(new CustomEvent('ec-drop-slider-reflow', { bubbles: true }));
      });
    };

    const markLandingLocked = (mode) => {
      lockedWidth = window.innerWidth;
      lockedMode = mode;
    };

    const getFoldHeights = (foldHeight) => {
      const heroHeight = Math.round(foldHeight * getHeroShare());
      const dropHeight = Math.max(0, foldHeight - heroHeight);
      return { heroHeight, dropHeight, valueHeight: 0 };
    };

    const isLandscapeMobile = () =>
      window.matchMedia('(max-width: 749px) and (orientation: landscape)').matches;

    const isCompactLandscape = () =>
      window.matchMedia('(orientation: landscape) and (max-height: 32rem)').matches;

    const isTabletPortrait = () =>
      window.matchMedia('(min-width: 750px) and (max-width: 989px) and (orientation: portrait)').matches;

    const getSlideWidthCap = () => {
      if (isCompactLandscape()) {
        return Math.min(Math.round(window.innerWidth * 0.2), 150);
      }

      if (window.matchMedia('(max-width: 749px) and (orientation: portrait)').matches) {
        return Math.round(window.innerWidth * 0.3);
      }

      if (window.matchMedia('(max-width: 749px)').matches) {
        return Math.round(window.innerWidth * 0.5);
      }

      if (isTabletPortrait()) {
        return Math.max(136, Math.round(window.innerWidth * 0.255));
      }

      return Math.min(Math.round(window.innerWidth * 0.52), 480);
    };

    const getLandingMode = () => {
      if (window.matchMedia('(max-width: 749px) and (orientation: portrait)').matches) {
        return 'portrait-mobile';
      }

      if (
        isCompactLandscape() &&
        window.matchMedia('(max-width: 989px)').matches
      ) {
        return 'compact-landscape';
      }

      if (window.matchMedia('(max-width: 749px) and (orientation: landscape)').matches) {
        return 'landscape-mobile';
      }

      if (window.matchMedia('(min-width: 750px) and (max-width: 989px)').matches) {
        return 'tablet';
      }

      if (window.matchMedia('(min-width: 990px)').matches) {
        return 'desktop';
      }

      return 'other';
    };

    const isStackedLandscapeMode = () =>
      isCompactLandscape() && body.classList.contains('ec-landing-landscape-fold');

    const isStackedFoldLayout = () =>
      body.classList.contains('ec-landing-stacked-fold') ||
      body.classList.contains('ec-landing-portrait-stacked-fold') ||
      isStackedLandscapeMode();

    const usesWidthFirstSlideSizing = () => {
      const mode = getLandingMode();
      return (
        mode === 'desktop' ||
        mode === 'tablet' ||
        mode === 'portrait-mobile' ||
        isTabletPortrait() ||
        isStackedFoldLayout()
      );
    };

    const fitDropSliderCards = (options = {}) => {
      const dropWrapper = document.querySelector(
        '#main-content > .shopify-section:has(.ec-drop-slider)'
      );
      const dropSlider = dropWrapper?.querySelector('.ec-drop-slider');
      if (!dropSlider || !dropWrapper) {
        return { carouselHeight: 0, slack: 0 };
      }

      body.style.setProperty('--ec-landing-drop-scale', '1');

      const intro = dropSlider.querySelector('.ec-drop-slider__intro');
      const introHeight = intro?.offsetHeight || 0;
      const dropHeightFromVar = readLandingVar('--ec-landing-drop-height');
      const dropHeight = Math.max(
        options.dropHeight || 0,
        dropWrapper.clientHeight,
        dropHeightFromVar,
        dropWrapper.offsetHeight
      );
      const available = Math.max(0, dropHeight - introHeight);

      const SLIDE_MIN = 72;
      const slideCap = getSlideWidthCap();
      const CARD_META_FALLBACK = 64;

      let cardMeta = dropSlider.querySelector('.ec-drop-slider__card-body')?.offsetHeight || CARD_META_FALLBACK;
      if (cardMeta < 48) cardMeta = CARD_META_FALLBACK;

      const isStackedFold = isStackedFoldLayout();

      let slideWidth;

      if (usesWidthFirstSlideSizing()) {
        slideWidth = Math.max(SLIDE_MIN, slideCap);
        dropSlider.style.setProperty('--ec-drop-slider-slide-width', `${Math.round(slideWidth)}px`);
        cardMeta = dropSlider.querySelector('.ec-drop-slider__card-body')?.offsetHeight || cardMeta;
      } else {
        slideWidth = Math.max(SLIDE_MIN, Math.min(slideCap, available - cardMeta));

        dropSlider.style.setProperty('--ec-drop-slider-slide-width', `${Math.round(slideWidth)}px`);

        cardMeta = dropSlider.querySelector('.ec-drop-slider__card-body')?.offsetHeight || cardMeta;
        slideWidth = Math.max(SLIDE_MIN, Math.min(slideCap, available - cardMeta));

        while (introHeight + cardMeta + slideWidth > dropHeight && slideWidth > SLIDE_MIN) {
          slideWidth -= 2;
        }
      }

      dropSlider.style.setProperty('--ec-drop-slider-slide-width', `${Math.round(slideWidth)}px`);
      dropSlider.style.setProperty('--ec-drop-slider-card-meta-offset', `${Math.round(cardMeta)}px`);

      const carouselHeight = introHeight + cardMeta + slideWidth;
      const slack = isStackedFold ? 0 : dropHeight - carouselHeight;

      if (isStackedFold) {
        const totalHeight = carouselHeight + 20;
        dropSlider.style.minHeight = `${totalHeight}px`;
        dropWrapper.style.minHeight = `${totalHeight}px`;
        if (isStackedLandscapeMode()) {
          body.style.setProperty('--ec-landing-drop-height', `${totalHeight}px`);
        }
      } else {
        dropSlider.style.removeProperty('min-height');
        dropWrapper.style.removeProperty('min-height');
      }

      const stage = dropSlider.querySelector('.ec-drop-slider__stage');
      const cardMedia = dropSlider.querySelector(
        '.ec-drop-slider__item:not([aria-hidden="true"]) .ec-drop-slider__card-media, .ec-drop-slider__card-media'
      );

      if (stage && cardMedia) {
        const stageRect = stage.getBoundingClientRect();
        const mediaRect = cardMedia.getBoundingClientRect();
        const arrowCenter = mediaRect.top + mediaRect.height / 2 - stageRect.top;

        dropSlider.querySelectorAll('.ec-drop-slider__arrow').forEach((arrow) => {
          arrow.style.top = `${Math.round(arrowCenter)}px`;
          arrow.style.bottom = 'auto';
          arrow.style.transform = 'translateY(-50%)';
        });
      }

      if (!options.silent) {
        dropSlider.dispatchEvent(
          new CustomEvent('ec-drop-slider-reflow', { bubbles: true, detail: { slideWidth, cardMeta } })
        );
      }

      return { carouselHeight, slack, introHeight, slideWidth, cardMeta };
    };

    const getLandscapeHeroBounds = (foldHeight) => {
      const copy = document.querySelector('.ec-hero__copy');
      const contentMin = copy ? copy.scrollHeight + 28 : 0;
      const share = getHeroShare();
      const preferred = Math.round(foldHeight * share);
      const minDrop = isCompactLandscape()
        ? Math.max(128, Math.round(foldHeight * 0.42))
        : 132;

      if (isLandscapeMobile() || isCompactLandscape()) {
        const maxHero = Math.max(0, foldHeight - minDrop);
        const minHero = Math.min(
          maxHero,
          Math.max(
            isLandscapeMobile() ? contentMin : 0,
            Math.round(foldHeight * (isCompactLandscape() ? 0.34 : share - 0.04))
          )
        );

        return {
          minHero,
          maxHero,
          initial: Math.min(maxHero, Math.max(minHero, preferred)),
        };
      }

      const minHero = Math.max(Math.round(foldHeight * 0.28), Math.round(foldHeight * (share - 0.22)));
      const maxHero = Math.max(minHero, foldHeight - minDrop);

      return {
        minHero,
        maxHero,
        initial: Math.min(maxHero, Math.max(minHero, preferred)),
      };
    };

    const applyFoldHeights = (foldHeight, heroHeight, dropHeight, modeClass) => {
      body.style.setProperty('--ec-landing-fold-height', `${foldHeight}px`);
      body.style.setProperty('--ec-landing-hero-height', `${heroHeight}px`);
      body.style.setProperty('--ec-landing-drop-height', `${dropHeight}px`);
      body.style.removeProperty('--ec-landing-value-height');
      body.classList.add('ec-landing-heights-locked');

      if (!modeClass) {
        return;
      }

      const modeClasses = [
        'ec-landing-landscape-fold',
        'ec-landing-portrait-stacked-fold',
        'ec-landing-stacked-fold',
      ];

      modeClasses.forEach((className) => {
        if (className === modeClass) {
          body.classList.add(className);
        } else {
          body.classList.remove(className);
        }
      });
    };

    const alignFoldToDropSection = (foldHeight, initialHeroHeight, modeClass) => {
      const dropWrapper = document.querySelector(
        '#main-content > .shopify-section:has(.ec-drop-slider)'
      );
      const dropSection = dropWrapper?.querySelector('.ec-drop-slider');

      const { minHero, maxHero, initial } = getLandscapeHeroBounds(foldHeight);
      let heroHeight = Math.min(maxHero, Math.max(minHero, initialHeroHeight || initial));
      let dropHeight = Math.max(0, foldHeight - heroHeight);

      if (!dropSection || !dropWrapper) {
        applyFoldHeights(foldHeight, heroHeight, dropHeight, modeClass);
        fitDropSliderCards({ dropHeight });
        return { foldHeight, heroHeight, dropHeight };
      }

      for (let attempt = 0; attempt < 24; attempt += 1) {
        dropHeight = Math.max(0, foldHeight - heroHeight);
        applyFoldHeights(foldHeight, heroHeight, dropHeight, modeClass);
        const { carouselHeight, slack } = fitDropSliderCards({
          silent: true,
          dropHeight,
        });

        let edgeDelta = 0;
        if (isLandingFoldAtRest()) {
          const targetBottom = getHeaderOffset() + foldHeight;
          const bottomEdge = Math.round(dropWrapper.getBoundingClientRect().bottom);
          edgeDelta = targetBottom - bottomEdge;
        }

        if (Math.abs(edgeDelta) <= 1 && Math.abs(slack) <= 2) {
          fitDropSliderCards({ dropHeight });
          return { foldHeight, heroHeight, dropHeight };
        }

        if (slack > 2 && !isCompactLandscape()) {
          const grow = Math.min(Math.round(slack), maxHero - heroHeight);
          if (grow > 0) {
            heroHeight += grow;
            continue;
          }
        }

        if (slack < -2 || carouselHeight > dropHeight + 1) {
          const overflow = Math.max(1, Math.round(Math.max(-slack, carouselHeight - dropHeight)));
          heroHeight = Math.max(minHero, heroHeight - overflow);
          continue;
        }

        if (edgeDelta > 1) {
          heroHeight = Math.max(minHero, heroHeight - Math.max(1, Math.round(edgeDelta * 0.6)));
        } else if (edgeDelta < -1) {
          heroHeight = Math.min(maxHero, heroHeight + Math.max(1, Math.round(Math.abs(edgeDelta) * 0.6)));
        }
      }

      applyFoldHeights(foldHeight, heroHeight, dropHeight, modeClass);
      fitDropSliderCards({ dropHeight });
      return { foldHeight, heroHeight, dropHeight };
    };

    const lockCompactLandscapeHeights = (force = false) => {
      if (!force && landscapeMetrics) {
        applyFoldHeights(
          landscapeMetrics.foldHeight,
          landscapeMetrics.heroHeight,
          landscapeMetrics.dropHeight,
          'ec-landing-landscape-fold'
        );
        fitDropSliderCards({ dropHeight: landscapeMetrics.dropHeight });
        return;
      }

      const mainTop = getHeaderOffset();
      const foldHeight = getFoldHeight();
      if (foldHeight <= 0) return;

      body.style.setProperty('--ec-landing-drop-scale', '1');
      body.style.setProperty('--ec-landing-hero-share', '1');

      applyFoldHeights(foldHeight, foldHeight, 0, 'ec-landing-landscape-fold');
      fitDropSliderCards({ dropHeight: 0 });

      landscapeMetrics = {
        foldHeight,
        heroHeight: foldHeight,
        dropHeight: 0,
        screenBottom: mainTop + foldHeight,
        mainTop,
      };
    };

    const lockLandscapeHeights = (force = false) => {
      lockCompactLandscapeHeights(force);
    };

    const lockPortraitStackedFoldHeights = (force = false) => {
      if (!force && portraitMetrics) {
        applyFoldHeights(
          portraitMetrics.foldHeight,
          portraitMetrics.heroHeight,
          portraitMetrics.dropHeight,
          'ec-landing-portrait-stacked-fold'
        );
        fitDropSliderCards({ dropHeight: 0 });
        return;
      }

      const mainTop = getMainContentTop();
      let foldHeight = getPortraitFoldHeight();
      if (foldHeight <= 0) return;

      const splitWrapper = document.querySelector(
        '#main-content > .shopify-section:has(.ec-gender-split-hero)'
      );

      body.style.setProperty('--ec-landing-drop-scale', '1');

      const splitEstimate = Math.round(window.innerWidth / 2);
      let splitHeight = splitEstimate;
      let heroHeight = Math.max(0, foldHeight - splitHeight);

      applyFoldHeights(foldHeight, heroHeight, 0, 'ec-landing-portrait-stacked-fold');

      for (let attempt = 0; attempt < 16; attempt += 1) {
        foldHeight = getPortraitFoldHeight();
        splitHeight = measureSplitHeroHeight();
        heroHeight = Math.max(0, foldHeight - splitHeight);

        const heroShare = foldHeight > 0 ? heroHeight / foldHeight : 0;
        body.style.setProperty('--ec-landing-hero-share', String(heroShare));
        body.style.setProperty('--ec-landing-split-hero-height', `${splitHeight}px`);
        applyFoldHeights(foldHeight, heroHeight, 0, 'ec-landing-portrait-stacked-fold');

        if (!splitWrapper || !isLandingFoldAtRest()) {
          break;
        }

        const targetBottom = getMainContentTop() + foldHeight;
        const actualBottom = Math.round(splitWrapper.getBoundingClientRect().bottom);
        const edgeDelta = targetBottom - actualBottom;

        if (Math.abs(edgeDelta) <= 1) {
          break;
        }

        heroHeight = Math.max(0, heroHeight + edgeDelta);
      }

      body.style.setProperty('--ec-landing-split-hero-height', `${splitHeight}px`);
      applyFoldHeights(foldHeight, heroHeight, 0, 'ec-landing-portrait-stacked-fold');
      fitDropSliderCards({ dropHeight: 0 });

      portraitMetrics = {
        foldHeight,
        heroHeight,
        dropHeight: 0,
        splitHeight,
        screenBottom: mainTop + foldHeight,
        mainTop,
      };
      portraitFoldSealed = true;
    };

    const lockStackedFoldHeights = (force = false) => {
      if (!force && stackedFoldMetrics) {
        applyFoldHeights(
          stackedFoldMetrics.foldHeight,
          stackedFoldMetrics.heroHeight,
          stackedFoldMetrics.dropHeight,
          'ec-landing-stacked-fold'
        );
        fitDropSliderCards({ dropHeight: 0 });
        return;
      }

      const mainTop = getHeaderOffset();
      const foldHeight = getFoldHeight();
      if (foldHeight <= 0) return;

      body.style.setProperty('--ec-landing-drop-scale', '1');
      body.style.setProperty('--ec-landing-hero-share', '1');

      applyFoldHeights(foldHeight, foldHeight, 0, 'ec-landing-stacked-fold');
      fitDropSliderCards({ dropHeight: 0 });

      stackedFoldMetrics = {
        foldHeight,
        heroHeight: foldHeight,
        dropHeight: 0,
        screenBottom: mainTop + foldHeight,
        mainTop,
      };
    };

    const lockLandingHeights = () => {
      const mode = getLandingMode();

      if (
        body.classList.contains('ec-landing-heights-locked') &&
        mode === lockedMode &&
        !isLandingFoldAtRest()
      ) {
        return;
      }

      if (mode !== lockedMode) {
        clearLocks();
      }

      if (mode === 'portrait-mobile') {
        if (isPortraitFoldFrozen()) {
          lockPortraitStackedFoldHeights(false);
          return;
        }

        lockPortraitStackedFoldHeights(true);
        markLandingLocked(mode);
        notifyDropSliderReflow();
        return;
      }

      if (mode === 'other') {
        clearLocks();
        markLandingLocked(mode);
        notifyDropSliderReflow();
        return;
      }

      if (mode === 'compact-landscape' || mode === 'landscape-mobile') {
        lockCompactLandscapeHeights(true);
        markLandingLocked(mode);
        notifyDropSliderReflow();
        return;
      }

      if (mode === 'tablet' || mode === 'desktop') {
        lockStackedFoldHeights(true);
        markLandingLocked(mode);
        notifyDropSliderReflow();
        return;
      }
    };

    const scheduleLock = (afterReflow = false) => {
      if (isPortraitFoldFrozen()) {
        return;
      }

      if (!isLandingFoldAtRest() && body.classList.contains('ec-landing-heights-locked')) {
        return;
      }

      if (lockFrame) cancelAnimationFrame(lockFrame);
      lockFrame = requestAnimationFrame(() => {
        lockFrame = requestAnimationFrame(() => {
          lockLandingHeights();
          if (afterReflow) {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(notifyDropSliderReflow);
            });
          }
        });
      });
    };

    const maybeRelock = (event) => {
      const mode = getLandingMode();
      const width = window.innerWidth;

      if (isPortraitFoldFrozen()) {
        if (Math.abs(width - lockedWidth) < 1) {
          return;
        }

        portraitFoldSealed = false;
        portraitMetrics = null;
      }

      if (
        mode === lockedMode &&
        body.classList.contains('ec-landing-heights-locked') &&
        Math.abs(width - lockedWidth) < 1
      ) {
        return;
      }

      if (!isInLandingFoldZone() && body.classList.contains('ec-landing-heights-locked')) {
        return;
      }

      if (mode === 'other') {
        clearLocks();
        markLandingLocked(mode);
        notifyDropSliderReflow();
        return;
      }

      clearLocks();
      scheduleLock(true);
    };

    const handleOrientationChange = () => {
      clearLocks();
      lockedWidth = 0;
      lockedMode = '';
      window.setTimeout(() => scheduleLock(true), 100);
      window.setTimeout(() => scheduleLock(true), 300);
    };

    const start = () => {
      scheduleLock();
      window.addEventListener('orientationchange', handleOrientationChange);
      window.addEventListener('resize', maybeRelock, { passive: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    if (document.fonts?.ready) {
      document.fonts.ready.then(scheduleLock);
    }

    window.addEventListener('load', scheduleLock, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ec-product-card"] && !Shopify.designMode) return;
  try {
    const getCardGalleryMaxIndex = (gallery) => {
    const count = parseInt(gallery.dataset.ecCardCount, 10);
    if (!Number.isNaN(count) && count > 0) return count - 1;
    return Math.max(0, gallery.querySelectorAll('.ec-product-card__image').length - 1);
  };

  const setCardGalleryImage = (gallery, index) => {
    if (!gallery) return;

    const maxIndex = getCardGalleryMaxIndex(gallery);
    const nextIndex = Math.max(0, Math.min(index, maxIndex));
    gallery.dataset.ecCardIndex = String(nextIndex);

    gallery.querySelectorAll('.ec-product-card__image').forEach((image) => {
      const imageIndex = parseInt(image.dataset.ecCardImageIndex, 10);
      image.classList.toggle('is-active', imageIndex === nextIndex);
    });

    const card = gallery.closest('.ec-product-card');
    if (!card) return;

    card.querySelectorAll('[data-ec-card-dot]').forEach((dot) => {
      const dotIndex = parseInt(dot.dataset.ecCardDotIndex, 10);
      const isActive = dotIndex === nextIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    const prev = card.querySelector('[data-ec-card-prev]');
    const next = card.querySelector('[data-ec-card-next]');
    if (prev) prev.disabled = nextIndex === 0;
    if (next) next.disabled = nextIndex >= maxIndex;
  };

  const initProductCardGalleries = () => {
    document.querySelectorAll('[data-ec-card-gallery]').forEach((gallery) => {
      if (gallery.dataset.ecCardGalleryReady === 'true') return;
      gallery.dataset.ecCardGalleryReady = 'true';

      if (getCardGalleryMaxIndex(gallery) < 1) return;

      setCardGalleryImage(gallery, parseInt(gallery.dataset.ecCardIndex, 10) || 0);

      let touchStartX = 0;

      gallery.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );

      gallery.addEventListener(
        'touchend',
        (event) => {
          const distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) < 40) return;

          const currentIndex = parseInt(gallery.dataset.ecCardIndex, 10) || 0;
          const maxIndex = getCardGalleryMaxIndex(gallery);

          if (distance < 0) {
            setCardGalleryImage(gallery, Math.min(maxIndex, currentIndex + 1));
          } else {
            setCardGalleryImage(gallery, Math.max(0, currentIndex - 1));
          }
        },
        { passive: true }
      );
    });
  };

  document.addEventListener('click', (event) => {
    const prev = event.target.closest('[data-ec-card-prev]');
    const next = event.target.closest('[data-ec-card-next]');
    const dot = event.target.closest('[data-ec-card-dot]');

    if (!prev && !next && !dot) return;

    event.preventDefault();
    event.stopPropagation();

    const gallery = (prev || next || dot)?.closest('.ec-product-card')?.querySelector('[data-ec-card-gallery]');
    if (!gallery) return;

    const currentIndex = parseInt(gallery.dataset.ecCardIndex, 10) || 0;
    const maxIndex = getCardGalleryMaxIndex(gallery);

    if (prev) setCardGalleryImage(gallery, currentIndex - 1);
    if (next) setCardGalleryImage(gallery, Math.min(maxIndex, currentIndex + 1));
    if (dot) setCardGalleryImage(gallery, parseInt(dot.dataset.ecCardDotIndex, 10) || 0);
  });

  initProductCardGalleries();
  document.addEventListener('shopify:section:load', initProductCardGalleries);

  const updateHeaderCartCount = async () => {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      const cart = await response.json();
      const cartLink = document.querySelector('.site-header__cart');

      if (!cartLink) return;

      let badge = cartLink.querySelector('.site-header__cart-count');

      if (cart.item_count > 0) {
        if (!badge) {
          badge = document.createElement('sup');
          badge.className = 'site-header__cart-count';
          cartLink.appendChild(badge);
        }
        badge.textContent = cart.item_count;
      } else if (badge) {
        badge.remove();
      }
    } catch (error) {
      /* ignore */
    }
  };

  const findCardVariant = (form) => {
    const productJson = form.querySelector('[data-ec-card-product-json]');
    if (!productJson) return null;

    const productData = JSON.parse(productJson.textContent);
    const useSizeVariants = form.dataset.ecUseSizeVariants === 'true';

    if (!useSizeVariants) {
      return productData.variants.find((variant) => variant.available) || productData.variants[0];
    }

    const selectedOptions = [];
    form.querySelectorAll('[data-ec-card-option-input]:checked:not(:disabled)').forEach((input) => {
      const index = parseInt(input.dataset.optionIndex, 10);
      if (!Number.isNaN(index)) {
        selectedOptions[index] = input.value;
      }
    });

    return productData.variants.find((variant) =>
      variant.options.every((option, index) => option === selectedOptions[index])
    );
  };

  const updateCardVariant = (form) => {
    const variant = findCardVariant(form);
    if (!variant) return;

    const variantInput = form.querySelector('[data-ec-card-variant-id]');
    const addButton = form.querySelector('[data-ec-card-add]');

    if (variantInput) variantInput.value = variant.id;

    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available
        ? addButton.dataset.labelAdd
        : addButton.dataset.labelSoldOut;
      addButton.classList.remove('is-added');
    }
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-ec-card-size]');
    if (!input) return;

    const form = input.closest('[data-ec-quick-add]');
    if (form) updateCardVariant(form);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ec-quick-add]');
    if (!form) return;

    event.preventDefault();

    const addButton = form.querySelector('[data-ec-card-add]');
    if (!addButton || addButton.disabled) return;

    const formData = new FormData(form);
    const variantId = Number(formData.get('id'));
    const sizeProperty = formData.get('properties[Size]');

    const item = {
      id: variantId,
      quantity: 1,
    };

    if (sizeProperty) {
      item.properties = { Size: sizeProperty };
    }

    addButton.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      addButton.textContent = addButton.dataset.labelAdded;
      addButton.classList.add('is-added');
      await updateHeaderCartCount();

      if (typeof window.ecOpenCartDrawer === 'function') {
        await window.ecOpenCartDrawer();
      }

      window.setTimeout(() => {
        updateCardVariant(form);
      }, 1800);
    } catch (error) {
      addButton.disabled = false;
      addButton.textContent = addButton.dataset.labelAdd;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ec-product-overview"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ec-overview-toggle]');
    if (!toggle) return;

    const overview = toggle.closest('[data-ec-product-overview]');
    const rest = overview?.querySelector('[data-ec-overview-rest]');
    if (!rest) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      toggle.setAttribute('aria-expanded', 'false');
      rest.hidden = true;
      toggle.textContent = toggle.dataset.labelMore || 'See more';
    } else {
      toggle.setAttribute('aria-expanded', 'true');
      rest.hidden = false;
      toggle.textContent = toggle.dataset.labelLess || 'See less';
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ec-size-chart-modal"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-ec-size-chart]').forEach((dialog) => {
    const openButtons = document.querySelectorAll(`[aria-controls="${dialog.id}"]`);

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        dialog.showModal();

        const focusSection = dialog.classList.contains('ec-size-chart--ladies-product')
          ? dialog.querySelector('.ec-size-chart__section--womens-rashguard')
          : dialog.querySelector('.ec-size-chart__section--mens-rashguard');

        focusSection?.scrollIntoView({ block: 'nearest' });
      });
    });

    dialog.querySelectorAll('[data-ec-size-chart-close]').forEach((button) => {
      button.addEventListener('click', () => {
        dialog.close();
      });
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ec-you-may-like-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ecYmalSelectInit) return;
    window.ecYmalSelectInit = true;

    const YMAL_MENU_OFFSET = 6;
    const YMAL_MENU_MAX_Z = 55;

    const ymalMenuAnchors = new WeakMap();

    const resetYmalMenuPosition = (menu) => {
      if (!menu) return;

      const wrap = ymalMenuAnchors.get(menu);
      menu.classList.remove('is-fixed');
      menu.style.position = '';
      menu.style.top = '';
      menu.style.left = '';
      menu.style.width = '';
      menu.style.right = '';
      menu.style.maxHeight = '';
      menu.style.overflowY = '';
      menu.style.zIndex = '';

      if (wrap && menu.parentElement === document.body) {
        wrap.appendChild(menu);
      }
    };

    const getYmalMenu = (wrap) => {
      const menuId = wrap.dataset.ecYmalMenuId;
      if (menuId) {
        return document.getElementById(menuId);
      }

      return wrap.querySelector('.ec-ymal-card__select-menu');
    };

    const positionYmalMenu = (wrap) => {
      const menu = getYmalMenu(wrap);
      const trigger = wrap.querySelector('.ec-ymal-card__select-trigger');
      if (!menu || !trigger) return;

      ymalMenuAnchors.set(menu, wrap);

      if (menu.parentElement !== document.body) {
        document.body.appendChild(menu);
      }

      const rect = trigger.getBoundingClientRect();
      const viewportPadding = 8;
      const availableBelow = window.innerHeight - rect.bottom - viewportPadding;
      const isMobileLandscape = window.matchMedia('(max-width: 749px) and (orientation: landscape)').matches;

      menu.classList.add('is-fixed');
      menu.style.position = 'fixed';
      menu.style.left = `${rect.left}px`;
      menu.style.width = `${rect.width}px`;
      menu.style.right = 'auto';
      menu.style.zIndex = String(YMAL_MENU_MAX_Z);
      menu.style.top = `${rect.bottom + YMAL_MENU_OFFSET}px`;
      menu.style.bottom = 'auto';

      menu.style.maxHeight = 'none';
      menu.style.overflowY = 'visible';
      const contentHeight = menu.scrollHeight;
      const spaceBelow = Math.max(0, availableBelow - YMAL_MENU_OFFSET);

      if (isMobileLandscape) {
        menu.style.maxHeight = `${contentHeight}px`;
        menu.style.overflowY = 'visible';
      } else {
        const maxHeight = Math.min(contentHeight, Math.max(72, spaceBelow));
        menu.style.maxHeight = `${maxHeight}px`;
        menu.style.overflowY = contentHeight > spaceBelow ? 'auto' : 'visible';
      }
    };

    const repositionOpenYmalMenus = () => {
      document.querySelectorAll('[data-ec-ymal-select-wrap].is-open').forEach((wrap) => {
        positionYmalMenu(wrap);
      });
    };

    const setYmalMenuOpenState = (wrap, isOpen) => {
      const card = wrap.closest('.ec-ymal-card');
      const item = wrap.closest('.ec-product__you-may-like-item');

      card?.classList.toggle('is-menu-open', isOpen);
      item?.classList.toggle('is-menu-open', isOpen);
    };

    const closeAllYmalMenus = () => {
      document.querySelectorAll('[data-ec-ymal-select-wrap].is-open').forEach((wrap) => {
        wrap.classList.remove('is-open');
        const menu = getYmalMenu(wrap);
        const trigger = wrap.querySelector('.ec-ymal-card__select-trigger');
        if (menu) {
          menu.hidden = true;
          resetYmalMenuPosition(menu);
        }
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        setYmalMenuOpenState(wrap, false);
      });

      document.querySelectorAll('.ec-ymal-card.is-menu-open').forEach((card) => {
        card.classList.remove('is-menu-open');
      });

      document.querySelectorAll('.ec-product__you-may-like-item.is-menu-open').forEach((item) => {
        item.classList.remove('is-menu-open');
      });
    };

    const initYmalSelect = (wrap) => {
      const select = wrap.querySelector('.ec-ymal-card__select-native');
      if (!select || wrap.dataset.ecYmalSelectInit === 'true') return;

      wrap.dataset.ecYmalSelectInit = 'true';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'ec-ymal-card__select-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', `${select.id}-menu`);

      const menu = document.createElement('ul');
      menu.id = `${select.id}-menu`;
      menu.className = 'ec-ymal-card__select-menu';
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;

      const syncTriggerLabel = () => {
        trigger.textContent = select.options[select.selectedIndex]?.textContent?.trim() || '';
        trigger.disabled = select.disabled;
      };

      const updateSelectedState = () => {
        menu.querySelectorAll('[data-ec-ymal-select-option]').forEach((item) => {
          const isSelected = item.dataset.value === select.value;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });
      };

      const rebuildMenu = () => {
        menu.innerHTML = '';

        Array.from(select.options).forEach((option) => {
          const item = document.createElement('li');
          item.className = 'ec-ymal-card__select-option';
          item.dataset.ecYmalSelectOption = '';
          item.dataset.value = option.value;
          item.setAttribute('role', 'option');
          item.textContent = option.textContent.trim();

          if (option.disabled) {
            item.classList.add('is-disabled');
            item.setAttribute('aria-disabled', 'true');
          }

          if (option.selected) {
            item.classList.add('is-selected');
            item.setAttribute('aria-selected', 'true');
          }

          item.addEventListener('mousedown', (event) => {
            event.preventDefault();
          });

          item.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (option.disabled) return;

            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            syncTriggerLabel();
            updateSelectedState();
            closeAllYmalMenus();
          });

          menu.appendChild(item);
        });
      };

      trigger.addEventListener('mousedown', (event) => {
        event.stopPropagation();
      });

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (select.disabled) return;

        const isOpen = wrap.classList.contains('is-open');

        if (isOpen) {
          closeAllYmalMenus();
          return;
        }

        closeAllYmalMenus();
        wrap.classList.add('is-open');
        setYmalMenuOpenState(wrap, true);
        menu.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (wrap.classList.contains('is-open')) {
              positionYmalMenu(wrap);
            }
          });
        });
      });

      select.addEventListener('change', () => {
        syncTriggerLabel();
        updateSelectedState();
      });

      wrap.appendChild(trigger);
      wrap.appendChild(menu);
      wrap.dataset.ecYmalMenuId = menu.id;
      rebuildMenu();
      syncTriggerLabel();
    };

    const initAllYmalSelects = (root = document) => {
      root.querySelectorAll('[data-ec-ymal-select-wrap]').forEach(initYmalSelect);
    };

    const findYmalVariant = (form) => {
      const productJson = form.querySelector('[data-ec-ymal-product-json]');
      if (!productJson) return null;

      const productData = JSON.parse(productJson.textContent);
      const useSizeVariants = form.dataset.ecUseSizeVariants === 'true';

      if (!useSizeVariants) {
        return productData.variants.find((variant) => variant.available) || productData.variants[0];
      }

      const selectedOptions = [];
      form.querySelectorAll('[data-ec-ymal-option-input]').forEach((input) => {
        const index = parseInt(input.dataset.optionIndex, 10);
        if (!Number.isNaN(index)) {
          selectedOptions[index] = input.value;
        }
      });

      return productData.variants.find((variant) =>
        variant.options.every((option, index) => option === selectedOptions[index])
      );
    };

    const updateYmalVariant = (form) => {
      const variant = findYmalVariant(form);
      if (!variant) return;

      const variantInput = form.querySelector('[data-ec-ymal-variant-id]');
      const addButton = form.querySelector('[data-ec-ymal-add]');

      if (variantInput) variantInput.value = variant.id;

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available
          ? addButton.dataset.labelAdd
          : addButton.dataset.labelSoldOut;
        addButton.classList.remove('is-added');
      }
    };

    const updateHeaderCartCount = async () => {
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) return;
        const cart = await response.json();
        const cartLink = document.querySelector('.site-header__cart');
        if (!cartLink) return;

        let badge = cartLink.querySelector('.site-header__cart-count');

        if (cart.item_count > 0) {
          if (!badge) {
            badge = document.createElement('sup');
            badge.className = 'site-header__cart-count';
            cartLink.appendChild(badge);
          }
          badge.textContent = cart.item_count;
        } else if (badge) {
          badge.remove();
        }
      } catch (error) {
        /* ignore */
      }
    };

    const boot = () => initAllYmalSelects();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-ec-ymal-select-wrap]')) {
        closeAllYmalMenus();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllYmalMenus();
      }
    });

    window.addEventListener('scroll', repositionOpenYmalMenus, true);
    window.addEventListener('resize', repositionOpenYmalMenus);

    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-ec-ymal-rashguard-size], [data-ec-ymal-shorts-size], [data-ec-ymal-option-input]');
      if (!input) return;

      const form = input.closest('[data-ec-ymal-quick-add]');
      if (form) updateYmalVariant(form);
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-ec-ymal-quick-add]');
      if (!form) return;

      event.preventDefault();

      const addButton = form.querySelector('[data-ec-ymal-add]');
      if (!addButton || addButton.disabled) return;

      const formData = new FormData(form);
      const variantId = Number(formData.get('id'));
      const rashguardProperty = formData.get('properties[Size - Rashguard]');
      const shortsProperty = formData.get('properties[Size - Compression Shorts]');

      const item = {
        id: variantId,
        quantity: 1,
      };

      const properties = {};

      if (rashguardProperty) {
        properties['Size - Rashguard'] = rashguardProperty;
      }

      if (shortsProperty) {
        properties['Size - Compression Shorts'] = shortsProperty;
      }

      if (Object.keys(properties).length > 0) {
        item.properties = properties;
      }

      addButton.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] }),
        });

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        addButton.textContent = addButton.dataset.labelAdded;
        addButton.classList.add('is-added');
        await updateHeaderCartCount();

        if (typeof window.ecOpenCartDrawer === 'function') {
          await window.ecOpenCartDrawer();
        }

        window.setTimeout(() => {
          updateYmalVariant(form);
        }, 1800);
      } catch (error) {
        addButton.disabled = false;
        addButton.textContent = addButton.dataset.labelAdd;
      }
    });

    document.addEventListener('shopify:section:load', (event) => {
      initAllYmalSelects(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
